// src/jira-servicedesk/request-type/types.ts
var JiraServicedeskRequestTypeAriResourceOwner = "jira-servicedesk", JiraServicedeskRequestTypeAriResourceType = "request-type";

export {
  JiraServicedeskRequestTypeAriResourceOwner,
  JiraServicedeskRequestTypeAriResourceType
};
